import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {reconcileLinkageStatistic} from 'src/openapi/admin/apis/CrmLinkageStatisticControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {CrmType} from 'src/openapi/admin/models/CrmType';

type Props = {
    accountId: number,
    crmType: CrmType,
};

export const useSyncLinkageStatistic = ({accountId, crmType}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        reconcileLinkageStatistic({accountId, crmType}),
    ), [accountId, crmType, apiDispatch]);

    return useCommonEventHook({eventAction});
};
